var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15957 11.8163C9.05957 11.8063 8.93957 11.8063 8.82957 11.8163C6.44957 11.7363 4.55957 9.78629 4.55957 7.38629C4.55957 4.93629 6.53957 2.94629 8.99957 2.94629C11.4496 2.94629 13.4396 4.93629 13.4396 7.38629C13.4296 9.78629 11.5396 11.7363 9.15957 11.8163Z",
    stroke: "#1F2933",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4103 4.94629C18.3503 4.94629 19.9103 6.51629 19.9103 8.44629C19.9103 10.3363 18.4103 11.8763 16.5403 11.9463C16.4603 11.9363 16.3703 11.9363 16.2803 11.9463",
    stroke: "#1F2933",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15973 15.5063C1.73973 17.1263 1.73973 19.7663 4.15973 21.3763C6.90973 23.2163 11.4197 23.2163 14.1697 21.3763C16.5897 19.7563 16.5897 17.1163 14.1697 15.5063C11.4297 13.6763 6.91973 13.6763 4.15973 15.5063Z",
    stroke: "#1F2933",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3398 20.9463C19.0598 20.7963 19.7398 20.5063 20.2998 20.0763C21.8598 18.9063 21.8598 16.9763 20.2998 15.8063C19.7498 15.3863 19.0798 15.1063 18.3698 14.9463",
    stroke: "#1F2933",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients);
export default __webpack_public_path__ + "static/media/patients.b3d733f40b27713b9990c94bb1dffc5d.svg";
export { ForwardRef as ReactComponent };